import Vue from 'vue'

import {
	Field,
	Button,
	Toast,
	CellGroup,
	Icon,
	Tabbar,
	TabbarItem,
	Swipe,
	SwipeItem,
	NoticeBar,
	Loading,
	Tag,
	Image,
	Cell,
	Checkbox,
	CheckboxGroup,
	SwipeCell,
	Popup,
	RadioGroup,
	Radio
} from 'vant'
Vue.use(Button).use(Field).use(Toast)
	.use(CellGroup).use(Icon).use(Tabbar).use(TabbarItem)
	.use(Swipe).use(SwipeItem).use(NoticeBar)
	.use(Loading).use(Tag).use(Image).use(Cell)
	.use(Checkbox).use(CheckboxGroup)
	.use(SwipeCell).use(Popup)
	.use(RadioGroup).use(Radio)
